import _ from 'lodash';

export default class Carac {

    type=''
    lieu=''
    clef=''
    valeur=''
    kw=[]

    constructor(type,lieu,clef,valeur) {
        this.type=type
        this.lieu=lieu
        this.clef=_.deburr(clef)
        this.valeur=""+valeur
        this.kw=this.clef.split('.')
    }


}